/* unplugin-vue-components disabled */import script from "./goodsConf.vue?vue&type=script&setup=true&lang=ts"
export * from "./goodsConf.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__